import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import MarketingDialog from "@/components/marketing/MarketingDialog";
import WaitlistForm, { type WaitlistAppearance } from "./WaitlistForm";

type WaitlistDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** "marketing" on the public marketing site; "default" everywhere else. */
  appearance?: WaitlistAppearance;
};

const TITLE = "Join the waitlist";
// Agent sign-up is open (founder decision F6); choosing Agent in the form
// offers sign-up instead of the list.
const DESCRIPTION = "Agents can create a free account right away. Teams and brokerages: tell us who you are and we'll be in touch.";

const WaitlistDialog = ({ open, onOpenChange, appearance = "default" }: WaitlistDialogProps) => {
  if (appearance === "marketing") {
    return (
      <MarketingDialog open={open} onOpenChange={onOpenChange} title={TITLE} description={DESCRIPTION}>
        <WaitlistForm appearance="marketing" />
      </MarketingDialog>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* Capped to the dynamic viewport and scrollable: the team-leader form is
          tall enough to overflow a short phone viewport or a zoomed desktop, and
          a centred fixed dialog with no cap puts its edges out of reach. */}
      <DialogContent className="max-h-[calc(100dvh-2rem)] overflow-y-auto sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{TITLE}</DialogTitle>
          <DialogDescription>{DESCRIPTION}</DialogDescription>
        </DialogHeader>
        <WaitlistForm />
      </DialogContent>
    </Dialog>
  );
};

export default WaitlistDialog;
